module.exports = "/images/vendor/vue2vis/dist/cross.png?260c9c6535065674bb5e59a73f894abb";